import BaseService from '@/services/BaseService'

class BancoService extends BaseService {
    constructor(){
        super('/v1/modelos-tanques')
    }
}

export default new BancoService